import { Link } from "react-router-dom";
import { Disc3 } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 border-t border-stroke bg-ink/80 backdrop-blur-sm px-6 lg:px-12 py-8">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Disc3 className="text-acid" size={20} />
          <span className="font-display text-xl text-paper">POSTERVAULT</span>
        </div>
        <div className="flex items-center gap-5 font-mono text-[11px] uppercase tracking-wider text-muted-gray">
          <Link to="/sponsorship" className="hover:text-acid" data-testid="footer-sponsorship-link">Sponsorship</Link>
          <Link to="/login" className="hover:text-acid">Log In</Link>
          <Link to="/register" className="hover:text-acid">Register</Link>
        </div>
        <div className="font-mono text-[11px] text-muted-gray text-center sm:text-right" data-testid="copyright-notice">
          © {year} PosterVault. All rights reserved.
          <span className="block text-muted-gray/70">Poster artwork © their respective artists.</span>
        </div>
      </div>
    </footer>
  );
}
